// Sending-domain DTOs mirror the API (PascalCase). Status values are the C# enum NAMES.

export interface DnsRecordDto {
  RecordType: string // label/purpose: DKIM | SPF | MX | Tracking
  Name: string // DNS host
  Type: string // DNS type: TXT | CNAME | MX
  Value: string
  Ttl?: string | null
  Priority?: number | null
  Status: string // SendingDomainRecordStatus name
}

export interface SendingDomainViewDto {
  Id: string
  ClientCompanyId: string
  Domain: string
  IsDefault: boolean // company default — auto-selected for activations + test sends
  Status: string // SendingDomainStatus name
  StatusMessage?: string | null
  Region?: string | null
  DnsRecords: DnsRecordDto[]
  StatusUpdatedUtc: string
  LastCheckedUtc?: string | null

  // Custom tracking subdomain label (e.g. "links"); null while on Resend's shared tracking domain.
  TrackingSubdomain?: string | null
  ClickTrackingEnabled: boolean
  OpenTrackingEnabled: boolean

  CreatedUtc: string
  UpdatedUtc: string
}

export interface SendingDomainCreateDto {
  Domain: string
  Region?: string
}

export interface ConfigureTrackingDto {
  // Single subdomain label (e.g. "links"); omit/blank to toggle flags without changing the subdomain.
  TrackingSubdomain?: string
  ClickTracking: boolean
  OpenTracking: boolean
}

// Resend delivery regions (Amazon SES) for data residency — EU first (the default).
export const SENDING_DOMAIN_REGIONS: { value: string; label: string }[] = [
  { value: 'eu-west-1', label: '🇮🇪 EU — Ireland (eu-west-1)' },
  { value: 'us-east-1', label: '🇺🇸 US East — N. Virginia (us-east-1)' },
  { value: 'sa-east-1', label: '🇧🇷 South America — São Paulo (sa-east-1)' },
  { value: 'ap-northeast-1', label: '🇯🇵 Asia Pacific — Tokyo (ap-northeast-1)' },
]

export const DEFAULT_SENDING_DOMAIN_REGION = 'eu-west-1'

// Overall verification is "done" at these states — polling stops here.
export const TERMINAL_DOMAIN_STATUSES = ['Verified', 'Failed', 'PartiallyFailed']

// Shared by both overall and per-record status pills (do NOT reuse INTEGRATION_STATUS_COLORS,
// which is keyed for integration health, not DNS verification).
export const DOMAIN_STATUS_COLORS: Record<string, string> = {
  NotStarted: 'bg-slate-200 text-slate-700 dark:bg-slate-700 dark:text-slate-200',
  Pending: 'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-300',
  Verified: 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300',
  Failed: 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300',
  TemporaryFailure: 'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-300',
  PartiallyVerified: 'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-300',
  PartiallyFailed: 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300',
}

export const DOMAIN_STATUS_LABELS: Record<string, string> = {
  NotStarted: 'Not started',
  Pending: 'Pending',
  Verified: 'Verified',
  Failed: 'Failed',
  TemporaryFailure: 'Temporary failure',
  PartiallyVerified: 'Partially verified',
  PartiallyFailed: 'Partially failed',
}
